import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { GroupAccountDirectBalance, GroupAccountReclassRequest, JournalEntry } from '../interfaces/accounting.interface';

export const GroupAccountReclassService = {
    /** Group accounts whose own (not rolled-up) posted balance is not zero. */
    list: async (): Promise<GroupAccountDirectBalance[]> => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(ENDPOINTS.GROUP_ACCOUNT_RECLASS.LIST(institutionId!));
        return response.data;
    },
    /** Posts one journal entry moving the group's whole direct balance to the target posting account. */
    reclassify: async (request: GroupAccountReclassRequest): Promise<JournalEntry> => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.post(ENDPOINTS.GROUP_ACCOUNT_RECLASS.RECLASSIFY(institutionId!), request);
        return response.data;
    },
};
